<script setup lang="ts"></script>

<template>
  <page-component>
    <about-components-version />
  </page-component>
</template>
